var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecycleScroller',{ref:"scroller",staticClass:"app-content-list",class:{ showdetails: _vm.selectedContact },attrs:{"id":"contacts-list","items":_vm.filteredList,"item-size":_vm.itemHeight,"key-field":"key"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(_vm.contacts[item.key])?_c('ContactsListItem',{key:item.key,attrs:{"contact":_vm.contacts[item.key],"index":index},on:{"deleted":_vm.selectContact}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }